import React from 'react';
import { expenseCategoryOptions } from '../utils/expenseCategories';

// The expense category picker: a fixed list, with a one-line hint of what
// belongs in the chosen category.
export default function ExpenseCategorySelect({ id, value, onChange, className, hintClassName = 'mt-1 text-xs text-gray-500' }) {
  const options = expenseCategoryOptions(value);
  const selected = options.find((option) => option.label === value);

  return (
    <>
      <select id={id} value={value || ''} onChange={(event) => onChange(event.target.value)} className={className} required>
        <option value="" disabled>Choose a category</option>
        {options.map((option) => (
          <option key={option.label} value={option.label}>
            {option.legacy ? `${option.label} (old category)` : option.label}
          </option>
        ))}
      </select>
      {selected?.hint ? <p className={hintClassName}>{selected.hint}</p> : null}
    </>
  );
}
